import Const from 'constants';

let PlayersDropzone = {
    toggleDropzone() {
        return (dispatch, getState) => {
            const {playersDropzone} = getState();

            if (playersDropzone.show) {
                dispatch({type: Const.HIDE_DROPZONE});

                return;
            }

            dispatch({type: Const.SHOW_DROPZONE});
        };
    },

    setDropzoneIsLoading() {
        return (dispatch) => {
            dispatch({type: Const.DROPZONE_IS_LOADING});
        };
    },

    setDropzoneIsNotLoading() {
        return (dispatch) => {
            dispatch({type: Const.DROPZONE_IS_NOT_LOADING});
        };
    },
};

export default PlayersDropzone;
